import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationClienteTipo } from '../integration-cliente-tipo';

@Injectable({
    providedIn: 'root'
})
export class IntegrationClienteTipoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/clientetipo`;
    }

    /** Executa a integração de leitura dos tipos de clientes com os sistemas ERP's */
    execReadIntegration(entity: IntegrationClienteTipo): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post(this.pathApi, null, {params, responseType: 'text'});
    }
}
